import React, { Component } from 'react'
import {CardElement, PostalElement, injectStripe} from 'react-stripe-elements';
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import { signUp } from '../../store/actions/authActions'
import {addNewPlan} from 'store/actions/billingActions';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import logo from "assets/img/logo-small.png";
import {Elements, StripeProvider} from 'react-stripe-elements';
import CheckoutForm from 'components/billing/CheckoutForm';
import Select from 'react-select';

const createOptions = () => {
  return {
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        fontFamily: 'Open Sans, sans-serif',
        letterSpacing: '0.025em',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#c23d4b',
      },
    }
  }
};

class SignUpForm extends Component {
  state = {
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    company: '',
    phone: '',
    plan: ''
  }
  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }

  
  handleSubmit = (e) => {
    e.preventDefault();
    
    (async () => {

      let {token} = await this.props.stripe.createToken({name: "Name"});
      if ((token !== undefined) && (token.id !== null) && (token.id !== undefined)) {

        this.props.signUp(this.state, token);
        
          
        
      }
    
      })();
  }

  handlePlanChange = (e) => {
    this.setState({
      plan: e.value
    })
  }

  render() {
    const { auth, authError } = this.props;
    let options = new Array();
    
    options.push({label: "Basic Plan", value: "Basic"});
    options.push({label: "Extended Plan", value: "Extended"});
    const customControlStyles = {
      control: (base, state) => ({
        ...base,
        minHeight: 32,
        
        width: 300,
        background: "#ffffff",
        autoWidth: false,
        
        borderRadius: state.isFocused ? "0px 0px 0 0" : 3,
        // Overwrittes the different states of border
        borderColor: state.isFocused ? "yellow" : "green",
        // Removes weird border around container
        boxShadow: state.isFocused ? null : null,
        "&:hover": {
          // Overwrittes the different states of border
          borderColor: state.isFocused ? "yellow" : "green"
        },
        padding: "0px",
        margin: "0px",
      })
    };

    return (
      
 
      <div className="container grey lighten-1">
        
        <form className="grey lighten-4" onSubmit={this.handleSubmit}>
          <div className="logo center" style={{display:"flex",flexDirection: "row" }}>
          <img src={logo}/> <p className="grey-text text-darken-3">CONSTRUWISE</p>
          </div>
          <h5 className="grey-text text-darken-3 center">Sign Up</h5>
          
          <div className="input-field">
            <label htmlFor="firstName">First Name</label>
            <input type="text" id='firstName' onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <label htmlFor="lastName">Last Name</label>
            <input type="text" id='lastName' onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <label htmlFor="lastName">Company Name</label>
            <input type="text" id='company' onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <label htmlFor="email">Email - Used for communication</label>
            <input type="email" id='email' onChange={this.handleChange} />
          </div>
          <PhoneInput
            placeholder="Phone - Used for SMS messages"
            onChange={ phone => this.setState({ phone }) }
          />
          <div className="input-field">
            <label htmlFor="password">Password</label>
            <input type="password" id='password' onChange={this.handleChange} />
          </div>
          
          
          <Select
          styles={customControlStyles}
          placeholder="Select A Plan ..."
          onChange={this.handlePlanChange}
          options={options}
          
          />
        {//<CardElement {...createOptions()}/>
         }
            

          <div className="input-field center">
            <button className="btn green z-depth-0">Sign Up</button>
            <div className="center red-text">
              { authError ? <p>{authError}</p> : null }
            </div>
          </div>
          
          
        </form>
      </div>
    )
  }
}



const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    authError: state.auth.authError
  }
}

const mapDispatchToProps = (dispatch)=> {
  return {
    signUp: (creds, token) => dispatch(signUp(creds, token)),
    addNewPlan: (planName) => dispatch(addNewPlan(planName))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(injectStripe(SignUpForm))



// WEBPACK FOOTER //
// ./src/components/auth/SignUpForm.js